import Section from "@components/Section";
import SimpleRichText from "@components/SimpleRichText";
import { Title } from "@justhome/react-ui";
import { ComponentSectionsHeadline } from "@lib/generated/graphql";
import { FC } from "react";

export interface HeadlineProps {
  data: ComponentSectionsHeadline;
  index: number;
}

const Headline: FC<HeadlineProps> = ({ data, index }) => {
  return (
    <Section section={data} className="my-3m m:mt-3xl m:mb-xl">
      {data.title && (
        <div className="max-w-[820px] m-auto text-center">
          <Title
            className={index === 0 ? "text-d3 m:text-d2" : "text-d3"}
            as={index === 0 ? "h1" : "h2"}
          >
            {data.title}
          </Title>
        </div>
      )}
      {data.subtitle && (
        <SimpleRichText className="text-body-1 text-neutral-575 mt-3s font-normal max-w-[680px] m-auto text-center">
          {data.subtitle}
        </SimpleRichText>
      )}
    </Section>
  );
};

export default Headline;
